module.exports = __webpack_public_path__ + "img/SEEWA.630471f4.svg";